
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-records-ui',
  currentProjectVersion: 'static-1.78221',
  depVersions: {
  "crm-records-ui": "static-1.78221",
  "ably": "static-2.2",
  "ably-hubspot-js": "static-2.3504",
  "ai-components-ui-library": "static-1.5426",
  "apollo-dlb": "static-3.41",
  "apollo-link-hub-http": "static-2.3709",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3929",
  "call-widget-addon": "static-2.28748",
  "calling-global-api": "static-1.58642",
  "calling-internal-common": "static-1.30168",
  "calling-lifecycle-internal": "static-1.60024",
  "card-associated-objects-lib": "static-1.39374",
  "card-associated-objects-lib-legacy": "static-1.7039",
  "card-linked-in-sales-navigator-lib": "static-1.36736",
  "card-preview-highlight-lib": "static-1.71349",
  "card-properties-lib": "static-1.39469",
  "client-types": "static-1.377",
  "commerce-contract-lib": "static-1.7055",
  "copilot-toolkit": "static-1.6936",
  "crm_data": "static-4.87280",
  "crm_ui": "static-5.87238",
  "crm-activity-creator-data": "static-1.41797",
  "crm-activity-creator-interactions-legacy": "static-1.31719",
  "crm-activity-creator-widgets": "static-1.47301",
  "crm-cards": "static-1.40068",
  "crm-cards-sdk": "static-1.38771",
  "crm-cards-test-utils": "static-1.38618",
  "crm-command-handler": "static-1.31595",
  "crm-common-dlb": "static-1.4241",
  "crm-events-data": "static-1.56420",
  "crm-fe-perf": "static-1.21932",
  "crm-legacy-global-containers": "static-1.22732",
  "crm-links": "static-1.5032",
  "crm-message-bus": "static-1.37527",
  "crm-object-map": "static-1.2277",
  "crm-pipeline-approvals-lib": "static-1.19754",
  "crm-timeline": "static-1.84745",
  "crm-timeline-tasks": "static-1.33085",
  "customer-data-communicator": "static-1.40868",
  "customer-data-email": "static-1.15962",
  "customer-data-objects": "static-1.6561",
  "customer-data-properties-shared-msw-handlers": "static-1.6557",
  "customer-data-sidebar": "static-2.41676",
  "customer-data-tracking": "static-1.5777",
  "data-fetching-client": "static-1.8567",
  "dispatcher": "static-1.113",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.306",
  "feedback-loader": "static-1.26781",
  "foundations-components": "static-1.6145",
  "foundations-theming-specialty": "static-1.968",
  "framework-data-schema-quick-fetch": "static-1.5717",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7313",
  "framework-data-table": "static-2.8914",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4043",
  "highcharts": "static-8.81",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6940",
  "hub-http": "static-1.4807",
  "hubspot-apollo-client": "static-1.3770",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10451",
  "I18n": "static-7.1395",
  "immutable": "static-2.19",
  "jasmine-console-invariants": "static-1.1672",
  "jasmine-immutable": "static-1.1899",
  "jasmine-runner": "static-1.5355",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.5977",
  "MeetingsLib": "static-2.53856",
  "msw": "static-1.39",
  "multi-currency-client-types": "static-1.2892",
  "onboarding-tours": "static-1.14598",
  "PortalIdParser": "static-2.284",
  "quartz": "static-1.5689",
  "quartz-core": "static-1.4908",
  "quick-fetch": "static-1.3079",
  "quotes-ui-lib": "static-1.75098",
  "raven": "static-3.4818",
  "react": "static-7.151",
  "react-dlb": "static-1.54",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-dom": "static-7.85",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.4425",
  "recording-review-components-lib": "static-1.27459",
  "reference-resolvers": "static-1.7090",
  "reporting-data": "static-1.62291",
  "reporting-dlb": "static-1.55209",
  "reporting-testing-lib": "static-1.4226",
  "reporting-visualizations": "static-1.54368",
  "sales-clients-common": "static-1.46429",
  "settings-ui-lib": "static-1.11478",
  "tinymce": "static-6.5",
  "ui-addon-avatars": "static-2.8157",
  "ui-addon-draggable": "static-2.1200",
  "ui-addon-opt": "static-4.7535",
  "UIComponents": "static-3.7398",
  "universal-associations-select": "static-1.9756",
  "usage-based-billing-components-lib": "static-1.4426",
  "usage-tracker": "static-1.6408",
  "usage-tracker-core": "static-1.6258",
  "webpack-env": "static-1.54",
  "ai-catchup-cards-lib": "static-1.3547",
  "avatar-components": "static-1.1409",
  "BizOpsCrmUIComponents": "static-1.41541",
  "call-timeline-event": "static-1.51943",
  "calling-error-reporting": "static-1.30174",
  "calling-integration-timeline-event": "static-1.14271",
  "calling-orchestration-shared-library": "static-1.30682",
  "calling-ui-library": "static-1.65941",
  "card-deal-collaborators-lib": "static-1.33543",
  "card-object-highlight-lib": "static-1.2810",
  "chatspot-widget-iframe": "static-1.16241",
  "commerce-billing-lib": "static-1.15322",
  "commerce-subscription-lib": "static-1.32147",
  "commerce-tools-ui-lib": "static-1.7105",
  "composer-plugins": "static-1.67296",
  "conversations-inbox-message-history": "static-1.30682",
  "conversations-message-history": "static-1.10038",
  "conversations-thread-view-crm-events": "static-1.30072",
  "crm_components": "static-3.87280",
  "crm_schema": "static-3.87318",
  "crm_universal": "static-1.20721",
  "crm-activity-creator-interaction-window": "static-1.41250",
  "crm-cards-dnd": "static-3.1095",
  "crm-cards-global-registry": "static-1.15648",
  "crm-display-components": "static-1.20780",
  "crm-extension": "static-1.36737",
  "crm-legacy-links": "static-1.72167",
  "crm-meetings-components-lib": "static-1.22254",
  "crm-realtime-lib": "static-1.98",
  "crm-object-preview": "static-1.22004",
  "crm-source-interpretation-lib": "static-1.4224",
  "crm-ui-legacy-tracking-page-view": "static-1.68298",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.524",
  "customer-data-filters": "static-1.48326",
  "customer-data-objects-ui-components": "static-1.11829",
  "customer-data-properties": "static-1.46466",
  "customer-data-property-utils": "static-1.6882",
  "customer-data-reference-ui-components": "static-1.11939",
  "customer-data-rte": "static-1.29472",
  "customer-data-ui-utilities": "static-1.8655",
  "deal-registration-ui": "static-1.30510",
  "deal-splits-cards-ui": "static-1.40337",
  "deal-splits-sidebar": "static-1.40243",
  "draft-email-branding-plugin": "static-2.20797",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.19505",
  "draft-signature-plugin": "static-1.20508",
  "email-confirm-ui": "static-2.4522",
  "EmailSignatureEditor": "static-1.21078",
  "ExportDialog": "static-6.9317",
  "ExtensionInstallHelpers": "static-1.540",
  "file-manager-components": "static-1.19152",
  "FileManagerLib": "static-1.34793",
  "flywheel-feedback-panel-components": "static-1.6218",
  "foundations-assets": "static-1.3849",
  "foundations-theming": "static-1.3251",
  "framework-data-schema-resolvers": "static-1.5812",
  "hubspot-prosemirror": "static-1.14188",
  "HubStyle": "static-2.10759",
  "icons": "static-2.592",
  "in-meeting-experience-ui-components": "static-1.17856",
  "InboxConnectUtils": "static-4.10395",
  "integration-settings-components": "static-1.10924",
  "lead-tracking-lib": "static-1.34826",
  "metrics-js": "static-1.8459",
  "mobile-manifest-mixins": "static-1.352",
  "native-integrations-shared-strings": "static-1.6761",
  "nav-meta": "static-1.25788",
  "object-builder-ui-client": "static-1.43040",
  "partner-shared-view-ui": "static-1.43090",
  "playbooks-modal": "static-1.75963",
  "playlists-lib": "static-1.7091",
  "products-ui-components": "static-1.35938",
  "property-history-panel": "static-1.19622",
  "property-management-iframe": "static-1.8758",
  "property-translator": "static-1.4352",
  "react-colorpicker": "static-2.9203",
  "react-immutable-proptypes": "static-2.8",
  "react-rhumb": "static-1.15503",
  "react-select-plus": "static-1.65",
  "reference-resolvers-lite": "static-1.6944",
  "reporting-action-components": "static-1.36903",
  "reporting-enablement": "static-1.17825",
  "reporting-ui-components": "static-2.59568",
  "rich-text-lib": "static-1.17649",
  "rpc-client-utils": "static-1.3667",
  "SafeStorage": "static-1.3339",
  "SalesContentIndexUI": "static-3.7301",
  "sanitize-text": "static-1.7102",
  "segment-references-panel-lib": "static-1.50988",
  "sequences-crm-events-lib": "static-1.24349",
  "sequences-crm-lib": "static-1.24546",
  "settings-ui-nav": "static-2.9031",
  "SharedI18nStrings": "static-1.163",
  "styled-components": "static-2.64",
  "subscriptions-components": "static-1.41877",
  "timezone-utils": "static-2.4174",
  "transcript-sidebar": "static-1.63540",
  "transmute": "static-2.29",
  "ui-addon-form-validation": "static-1.9967",
  "ui-addon-i18n": "static-1.9849",
  "ui-addon-iframeable": "static-1.7826",
  "ui-addon-scriptloader": "static-1.11321",
  "ui-addon-teams": "static-1.19958",
  "ui-addon-upgrades": "static-9.16204",
  "ui-asset-management-lib": "static-1.9245",
  "ui-business-units-lib": "static-1.7837",
  "ui-extensions-remote-renderer": "static-1.13122",
  "ui-gdpr-components": "static-1.9175",
  "ui-product-approvals": "static-1.24225",
  "ui-shepherd-react": "static-3.8996",
  "ui-suspension-banners-lib": "static-1.5351",
  "usage-tracker-container": "static-1.6398",
  "usage-tracker-session-replay": "static-1.4094",
  "atom": "static-1.4104",
  "hs-lodash": "static-4.45",
  "planout": "static-5.12",
  "react-immutable-render-mixin": "static-1.9",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.43",
  "sanitize": "static-1.3312",
  "hs-promise-rejection-tracking": "static-1.4356",
  "raven-hubspot": "static-1.5125",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3063",
  "react-redux": "static-7.16",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.2558",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.1966",
  "quartz-webpack": "static-1.1913",
  "hs-promise-utils": "static-1.4477",
  "autolinker": "static-3.11",
  "chatspot-client-types": "static-1.8823",
  "chatspot-core": "static-1.16248",
  "ContentUtils": "static-1.63788",
  "foundations-theming-base": "static-1.2236",
  "hs-story-utils": "static-1.8312",
  "sassPrefix": "static-1.132",
  "ui-fonts": "static-1.332",
  "ui-images": "static-2.872",
  "graphql": "static-1.59",
  "calling-client-interface": "static-1.71181",
  "calling-cross-tab-library": "static-1.18148",
  "calling-integration-cross-tab": "static-1.18345",
  "calling-integration-sdk-support": "static-1.26571",
  "calling-lifecycle-messages": "static-1.52318",
  "calling-lifecycle-usage-tracker": "static-1.5106",
  "calling-usage-tracker": "static-1.5438",
  "content-assistance-lib": "static-1.6483",
  "conversations-async-data": "static-2.6590",
  "conversations-prop-types": "static-1.6386",
  "conversations-skeleton-state": "static-1.6314",
  "customer-data-content": "static-1.24757",
  "immer": "static-1.33",
  "PatternValidationJS": "static-1.437",
  "self-service-api": "static-1.9143",
  "shared-worker-versioning": "static-1.10003",
  "onboarding-scopes": "static-1.5492",
  "frontend-preferences-client": "static-1.6829",
  "campaigns-lib": "static-1.22822",
  "card-payment-highlight-lib": "static-1.32575",
  "commerce-subscription-cards-lib": "static-1.26971",
  "credit-memos-iframe-lib": "static-1.7005",
  "crm-pipelines-api-client-types": "static-1.3209",
  "growth-payments-core": "static-1.21588",
  "payment-link-components": "static-1.19292",
  "payments-embed-points-lib": "static-1.9882",
  "persist-promise": "static-1.2682",
  "commerce-shared-components-lib": "static-1.15119",
  "draft-content-plugins": "static-1.24836",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "FireAlarmUi": "static-1.3722",
  "inbound-db-meta-service-client": "static-1.2887",
  "multi-account-crm-panel-lib": "static-1.13006",
  "portal-alert-banners-lib": "static-1.1132",
  "react-virtualized": "static-2.74",
  "reselect": "static-2.16",
  "sequences-lib": "static-1.6123",
  "superstore": "static-1.3716",
  "ui-partner-confirmation-links-components": "static-1.22723",
  "enrichment-properties-lib": "static-1.10591",
  "inbound-db-properties-service-client": "static-1.3048",
  "utility-belt": "static-1.1492",
  "zustand": "static-1.51",
  "crm-events-components": "static-1.56406",
  "hub-http-contrib": "static-1.2097",
  "prosemirror": "static-1.13",
  "react-dnd-compat": "static-1.3598",
  "task-forms-lib": "static-1.36750",
  "task-queues": "static-1.29733",
  "ui-addon-video-player": "static-1.7729",
  "location-customization-utils-lib": "static-1.4532",
  "react-grid-layout": "static-3.35",
  "crm-actions": "static-1.5020",
  "redux-toolkit": "static-1.7",
  "customer-data-sidebar-test-utils": "static-1.36354",
  "all-properties-panel-lib": "static-1.3536",
  "card-company-summary-lib": "static-1.14786",
  "card-engagement-attachments-lib": "static-1.68728",
  "card-integration-card-lib": "static-1.68587",
  "crm-events-viz-core": "static-1.28924",
  "crm-events-viz-timeline": "static-1.36587",
  "crm-record-access-management-lib": "static-1.22274",
  "customer-data-filters-ui": "static-1.34511",
  "customer-data-modals": "static-1.3786",
  "framework-scoring-history-panel-lib": "static-1.10740",
  "invoices-iframe-lib": "static-1.52153",
  "merge-modal-lib": "static-1.7452",
  "panel-deal-registration-ai-summary-lib": "static-1.23111",
  "predictive-scores-panel": "static-1.25668",
  "property-description-translator": "static-1.2804",
  "prospecting-agent-lib": "static-1.8131",
  "redux-mock-store": "static-1.8",
  "crm-index-visualization-object-layout": "static-1.1173",
  "crm-object-search-query-utilities": "static-1.6587",
  "collaboration-sidebar": "static-1.53192",
  "outpost": "static-1.3294",
  "pipeline-validation-client-types": "static-1.3007",
  "user-context": "static-1.4134",
  "accounting-extension-card-ui": "static-1.32197",
  "ai-addon-copilot-preview": "static-1.4638",
  "analytics_js": "static-1.3442",
  "attribution-sidebar-cards": "static-1.39567",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.18145",
  "crm-events": "static-1.56413",
  "feedback-schema": "static-1.49636",
  "FileManagerCore": "static-1.34652",
  "flux-actions": "static-1.276",
  "flywheel-lead-visibility-lib": "static-1.1996",
  "forms-utils-lib": "static-1.10428",
  "FormsCommonComponents": "static-1.81552",
  "FormUrlGenerator": "static-2.3665",
  "getting-started-shared-tasks": "static-1.13355",
  "integrations-lib": "static-1.11168",
  "integrations-tracking-lib": "static-1.4472",
  "MeetingsBase": "static-1.55448",
  "partner-poi-timeline-event": "static-1.35792",
  "project-storage": "static-1.3636",
  "qualified-leads-embedded-lib": "static-1.43226",
  "quotes-crm-events-lib": "static-1.38471",
  "quotes-modal-lib": "static-1.97055",
  "react-table": "static-1.15",
  "report-customization-components": "static-1.9292",
  "reporting-snowflake": "static-1.50912",
  "salesforce-sync-card-ui": "static-1.7912",
  "salesImages": "static-1.501",
  "sequences-client-types-lib": "static-1.5980",
  "share-transcript-modal": "static-1.53185",
  "social-components-lib": "static-1.29209",
  "StyleGuideUI": "static-3.464",
  "svh-tickets-lib": "static-1.14555",
  "ui-addon-integrations-directory-panel": "static-2.6962",
  "ui-addon-react-router-dom": "static-1.8552",
  "ui-addon-sales-email": "static-1.4137",
  "ui-tour-react": "static-1.10922",
  "urlinator": "static-1.3478",
  "hubspot-prosemirror-plugins": "static-1.14180",
  "outreach-assistant-email-generation": "static-1.3286",
  "quotes-client-types": "static-1.32467",
  "sales-email-signature-service-client": "static-1.2904",
  "conditional-properties-service-client": "static-1.3016",
  "external-options-client-types": "static-1.3223",
  "inbounddb-objects-service-types": "static-1.3318",
  "card-subscription-highlight-lib": "static-1.34570",
  "invoices-highlight-card-lib": "static-1.50079",
  "orders-highlight-card-lib": "static-1.17682",
  "products-highlight-card-lib": "static-1.13703",
  "quotes-highlight-card-lib": "static-1.66384",
  "wootric-nps": "static-1.5840",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.2414",
  "floating-ui": "static-1.29",
  "framer-motion": "static-1.41",
  "react-aria": "static-1.39",
  "tanstack-table": "static-1.23",
  "framework-builder-read-service-client": "static-1.3166",
  "customer-data-associations": "static-1.6140",
  "smart-property-lib": "static-1.1472",
  "testing-library": "static-1.121",
  "HeadJS": "static-2.581",
  "hs-test-utils-bend-plugin": "static-1.2051",
  "i18n-data": "static-1.198",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.3281",
  "foundations-components-test-utils": "static-1.3630",
  "laboratory-lib": "static-3.6176",
  "react-transition-group": "static-1.7",
  "redux-actions": "static-3.7",
  "signup-constants": "static-1.16530",
  "signup-ui-lego-core": "static-1.18540",
  "signup-ui-url-generator": "static-2.6992",
  "underscore": "static-1.8",
  "usage-tracker-anonymous": "static-1.4825",
  "usage-tracker-multi": "static-1.4822",
  "usage-tracker-public": "static-1.6219",
  "viral-links-lib": "static-1.5821",
  "ts-schema": "static-1.3231",
  "growth-data-modal": "static-1.4163",
  "growth-onboarding-confetti": "static-1.2038",
  "growth-onboarding-next-action-utils": "static-1.169",
  "navigation-components": "static-1.14151",
  "ui-shepherd-tracker": "static-1.6377",
  "ui-universal-auth": "static-1.7753",
  "quartz-core-utils": "static-1.2556",
  "hub-http-janus": "static-1.654",
  "hub-http-shared-msw-handlers": "static-1.7229",
  "hubspotter-http": "static-1.3689",
  "hubspotter-http-shared-msw-handlers": "static-1.7227",
  "platform-navigation-bootstrap": "static-1.11370",
  "commerce-tours-lib": "static-1.3874",
  "csstype": "static-1.38",
  "call-summary": "static-1.33334",
  "object-comments-thread-lib": "static-1.6640",
  "reporting-client-types": "static-1.2019",
  "ui-coaching-tips": "static-1.23629",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9407",
  "rxjs": "static-5.10",
  "react-flip-move": "static-1.47",
  "onboarding-tours-client": "static-1.3430",
  "subscription-experience-data-types": "static-1.11288",
  "breeze-intelligence-kit": "static-1.4189",
  "crm-component-utils": "static-1.35030",
  "crm-properties-list": "static-1.34055",
  "activity-history-lib": "static-1.3134",
  "assisted-buying-components": "static-1.6054",
  "bet-customer-success-shared-ui": "static-1.12493",
  "company-details-components": "static-1.4871",
  "company-details-service-types": "static-1.2894",
  "final-form": "static-1.40",
  "flywheel-recent-conversions-lib": "static-1.2804",
  "industries-core": "static-1.5696",
  "payment-method-components": "static-1.5518",
  "quote-checkout-common-lib": "static-1.9953",
  "quote-checkout-service-types": "static-1.2530",
  "ui-addon-draggable-compat": "static-2.3204",
  "conversations-calling-message": "static-1.55721",
  "crm-events-viz-test-utils": "static-1.17545",
  "calling-orchestration-schema": "static-1.30907",
  "twilio-voice-sdk": "static-1.51",
  "worker-connection-library": "static-1.12735",
  "commerce-analytics-service-client": "static-1.2643",
  "cv-backend-services": "static-1.1221",
  "growth-onboarding-empty-states": "static-1.4187",
  "payments-enrollment-embed-lib": "static-1.18228",
  "payments-post-enroll-local-storage-lib": "static-1.4026",
  "qrcode-generator": "static-1.44",
  "conversations-infrastructure": "static-1.7873",
  "conversations-internal-schema": "static-1.11577",
  "conversations-error-reporting": "static-1.7872",
  "immutable-less": "static-1.3490",
  "composer-data": "static-1.26210",
  "conversations-http": "static-1.3738",
  "conversations-internal-pub-sub": "static-1.14946",
  "conversations-platform": "static-1.3423",
  "conversations-thread-data": "static-1.63408",
  "zorse-crm-components-lib": "static-1.5964",
  "crm-activity-creator-interactions": "static-1.40522",
  "adobe-sign-cards-lib": "static-1.14423",
  "ai-dynamic-card": "static-1.969",
  "automation-ui-crm-card-workflows-invoker": "static-1.6034",
  "bundle-about-card": "static-1.1803",
  "bundle-items-card": "static-1.2447",
  "buyer-intent-card": "static-1.17114",
  "buying-group-card": "static-1.1561",
  "card-call-summaries-lib": "static-1.31030",
  "card-customer-spend-trends-lib": "static-1.22188",
  "card-flywheel-activity-history-lib": "static-1.3128",
  "card-flywheel-company-overview-lib": "static-1.12157",
  "card-flywheel-domain-review-history-lib": "static-1.1785",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.12157",
  "card-guest-access-management-lib": "static-1.3858",
  "card-guided-execution-activities": "static-1.5439",
  "card-knowledge-base-lib": "static-1.7563",
  "card-lead-insights": "static-1.10883",
  "card-lead-qualification-lib": "static-1.25913",
  "card-object-summary-lib": "static-1.3239",
  "card-other-tickets-lib": "static-1.15838",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.26918",
  "card-partner-client-unified-usage-score-lib": "static-1.21283",
  "card-prospecting-research-agent": "static-1.3771",
  "card-target-account-signals": "static-1.2320",
  "card-tasks-timeline-lib": "static-1.10428",
  "card-ticket-summary-lib": "static-1.12275",
  "commerce-billing-engine-lib": "static-1.2593",
  "commerce-payment-dispute-card": "static-1.1000",
  "crm-associations-pivot": "static-1.35009",
  "crm-associations-table": "static-1.36879",
  "crm-attribution-report": "static-1.1333",
  "crm-clv-report": "static-1.3667",
  "crm-csat": "static-1.939",
  "crm-data-highlights": "static-1.37417",
  "crm-events-viz-cards": "static-1.36578",
  "crm-events-viz-totals": "static-1.28132",
  "crm-nps": "static-1.815",
  "crm-property-history": "static-1.12115",
  "crm-quick-actions": "static-1.13565",
  "crm-relative-timeline": "static-1.13993",
  "crm-report": "static-1.37624",
  "crm-simple-deadline": "static-1.14211",
  "crm-stage-tracker": "static-1.32588",
  "crm-statistics": "static-1.26633",
  "custom-events-card-lib": "static-1.681",
  "customer-overview-card-lib": "static-1.5553",
  "customer-success-contacts-card-lib": "static-1.14251",
  "deal-summary-components": "static-1.17068",
  "docusign-cards-lib": "static-1.23597",
  "flywheel-growth-plans-crm-card": "static-1.3028",
  "guided-actions-card": "static-1.10278",
  "guided-selling-stage-tracker-card": "static-1.7900",
  "health-score-card-lib": "static-1.17534",
  "intelligence-overview-card": "static-1.10946",
  "intelligence-overview-lib": "static-1.9280",
  "invoices-history-card-lib": "static-1.26506",
  "lead-scores-card": "static-1.13584",
  "legacy-sidebar-card-lib": "static-1.30903",
  "partner-ai-summary-crm-card": "static-1.3219",
  "payment-schedule-card-lib": "static-1.24394",
  "playbooks-card": "static-1.38673",
  "predictive-scores-card": "static-1.26666",
  "process-guide-cards": "static-1.4062",
  "products-cards-lib": "static-1.5009",
  "purchase-history-lib": "static-1.16085",
  "ui-google-drive-attachments": "static-1.2651",
  "ui-google-drive-insights": "static-1.2653",
  "content-embed-lib": "static-1.6285",
  "remote-ui": "static-1.40",
  "ui-extensions-plugin-flywheel": "static-1.10063",
  "credit-memos-highlight-card-lib": "static-1.6357",
  "deep-diff": "static-1.5",
  "commerce-products-lib": "static-1.5418",
  "google-libphonenumber": "static-1.12",
  "video-components-external": "static-1.6515",
  "video-data-lib": "static-1.30168",
  "FileManagerImages": "static-1.32303",
  "bend-plugin-foundations-theming": "static-1.1734",
  "batch-promise": "static-1.524",
  "knowledge-content-types": "static-1.7757",
  "ui-addon-emoji-picker": "static-1.8879",
  "card-playbooks-lib": "static-1.58790",
  "in-meeting-experience-client-types": "static-1.14557",
  "marketplace-embed": "static-1.17353",
  "crm-record-cards-service-types": "static-1.2847",
  "ui-components-test-utils": "static-1.4589",
  "universal-page-editor-lib": "static-1.1888",
  "card-sales-activities-timeline": "static-1.34195",
  "partner-shared-messages-lib": "static-1.13886",
  "property-management-common": "static-1.1044",
  "dashboard-lib": "static-1.76507",
  "share-with-third-party-component-lib": "static-1.7597",
  "data-quality-ui-library": "static-1.8696",
  "html-to-image": "static-1.30",
  "markdown-it": "static-1.6",
  "reporting-plugins": "static-1.7285",
  "reporting-reports": "static-1.61974",
  "data-token-picker": "static-1.14304",
  "sales-templates-service-types-lib": "static-1.3289",
  "account-and-billing-components": "static-1.16837",
  "growth-feature-usage-components": "static-1.4947",
  "subscriptions-client": "static-1.42119",
  "magpie-lib": "static-1.4595",
  "navigation-messaging": "static-1.3478",
  "feature-store-service-types": "static-1.3643",
  "growth-monetization-service-types": "static-1.3650",
  "upgrade-management-service-types": "static-1.3634",
  "ui-extensibility-client-types": "static-1.3094",
  "amplitude-session-replay-browser": "static-1.33",
  "cms-field-types": "static-1.3719",
  "content-icons-ui": "static-1.1934",
  "attribution-lib": "static-1.38225",
  "campaigns-build-lib": "static-1.8718",
  "marketing-platform-lib": "static-1.5623",
  "credit-memos-ui-lib": "static-1.7003",
  "growth-onboarding-reliability": "static-1.4093",
  "sales-checkout-service-client": "static-1.2655",
  "fsm": "static-1.2676",
  "policy-lib": "static-1.5708",
  "customer-data-filters-ui-msw-helpers": "static-1.16944",
  "automation-ui-core": "static-2.16679",
  "automation-ui-permissions": "static-1.15039",
  "framework-scoring-client-types": "static-1.11793",
  "invoices-ui-lib": "static-1.50095",
  "predictive-scores-lib-components": "static-1.24063",
  "magpie-types": "static-1.4055",
  "simple-logging-lib": "static-1.1973",
  "getting-started-shared-tasks-store": "static-1.12473",
  "ai-settings-ui-library": "static-1.6067",
  "crm-pipeline-events-ui": "static-1.23943",
  "audio-components": "static-1.4618",
  "video-components": "static-1.8518",
  "video-embed": "static-1.31007",
  "flywheel-reject-ql-lib": "static-1.2825",
  "portal-details-components": "static-1.14852",
  "forms-ai-lib": "static-1.2393",
  "react-tinymce": "static-1.51143",
  "SharedLegalStrings": "static-1.1314",
  "tinymce-config": "static-2.50269",
  "integrations-error-boundary-lib": "static-1.8583",
  "meetings-client-types": "static-1.2866",
  "reporting-datasets-permissions-lib": "static-1.8319",
  "data-model-commons-lib": "static-1.7830",
  "growth-onboarding-feedback-components": "static-1.5408",
  "messaging-types-lib": "static-1.41080",
  "accounting-integrations-ui-components": "static-1.5099",
  "products-iframe-lib": "static-1.3744",
  "products-ui-components-shared-msw-handlers": "static-1.7612",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.7375",
  "emoji-regex": "static-1.7",
  "idb-keyval": "static-1.21",
  "platform-infra-nav-components": "static-1.6799",
  "trellis-story-utils": "static-1.3501",
  "fintech-buying-service-clients": "static-1.2511",
  "storybook-react": "static-1.4",
  "account-and-billing-contacts-usage": "static-2.18295",
  "signup-ui-full-screen-search": "static-1.10312",
  "billing-payments-client-types": "static-1.2920",
  "buying-experience-components": "static-1.8784",
  "checkout-service-types": "static-1.3004",
  "growth-pro-utils-lib": "static-1.9394",
  "marketplace-ui-apps-core": "static-1.13463",
  "stripe-embedded-components": "static-1.5443",
  "conversations-routing-lib": "static-1.7121",
  "routing-ui": "static-1.16818",
  "codemirror": "static-5.72",
  "react-codemirror": "static-1.9541",
  "automation-enrollment-service-types": "static-1.2830",
  "automation-platform-service-types": "static-1.2190",
  "automation-ui-ubb": "static-1.662",
  "commerce-products-api": "static-1.366",
  "buyer-intent-lib": "static-1.1776",
  "domain-review-history-lib": "static-1.3213",
  "renewal-center-service-types": "static-1.3097",
  "recent-activities-card": "static-1.54270",
  "submissions-lib": "static-1.42455",
  "ui-forms-components": "static-1.8423",
  "customer-success-client-types": "static-1.15506",
  "sales-enablement-lib": "static-1.13136",
  "sales-leader-insights-components-lib": "static-1.14372",
  "guided-actions-lib": "static-1.15651",
  "schedule-lib": "static-1.11075",
  "framework-scoring-components-lib": "static-1.12203",
  "card-bet-associated-companies-lib": "static-1.72429",
  "card-bet-deal-support-requests-lib": "static-1.63170",
  "card-bet-quotes-lib": "static-1.72436",
  "card-biz-ops-customer-success-lib": "static-1.72450",
  "card-biz-ops-domain-controls-lib": "static-1.72451",
  "card-biz-ops-related-contacts-lib": "static-1.72450",
  "card-crm-attribution-lib": "static-1.50848",
  "card-customer-success-lib": "static-1.655",
  "card-deal-shared-view-lib": "static-1.64175",
  "card-deal-splits-lib": "static-1.39723",
  "card-flywheel-ql-summary-lib": "static-1.41316",
  "card-flywheel-recent-conversions-lib": "static-1.41317",
  "card-gdpr-subscriptions-card-lib": "static-1.42579",
  "card-invoices-lib": "static-1.51970",
  "card-lists-lib": "static-1.66921",
  "card-marketing-event-about-lib": "static-1.51752",
  "card-marketing-event-activity-lib": "static-1.51751",
  "card-past-conversations-lib": "static-1.32832",
  "card-past-feedback-lib": "static-1.37531",
  "card-payment-history-lib": "static-1.32439",
  "card-profile-products-lib": "static-1.52704",
  "card-profile-quotes-lib": "static-1.79902",
  "card-prospecting-notes": "static-1.34195",
  "card-qualified-leads-lib": "static-1.72591",
  "card-sfdcsync-lib": "static-1.51822",
  "card-target-account-lib": "static-1.68534",
  "card-website-activity-lib": "static-1.69254",
  "card-workflows-lib": "static-1.68675",
  "integrations-sync-card-ui": "static-1.22749",
  "invoices-card-lib": "static-1.52222",
  "marketing-event-cards-ui": "static-1.32731",
  "orders-card-lib": "static-1.17399",
  "partner-poi-crm-card": "static-1.15758",
  "recording-preview-card": "static-1.12808",
  "surveymonkey-crm-card": "static-1.36218",
  "ui-sales-order-wizard-card": "static-1.27753",
  "sales-execution-components": "static-1.9172",
  "process-guide-chirp": "static-1.3894",
  "gapi-client-types": "static-1.5",
  "google-picker-types": "static-1.5",
  "ui-google-drive-commons": "static-1.787",
  "ui-google-drive-picker": "static-1.2222",
  "content-media-compositions": "static-2.10908",
  "immerable": "static-1.3084",
  "media-bridge-lib": "static-1.16908",
  "marketplace-ui-client-types": "static-1.12334",
  "marketplace-ui-common": "static-1.14927",
  "marketplace-ui-details": "static-1.4826",
  "trellis-ecosystem": "static-1.4891",
  "campaign-roi-lib": "static-1.3786",
  "account-and-billing-fintech-outages": "static-3.15587",
  "fintech-outages-service-client-types": "static-1.12587",
  "transactions-exp-service-client-types": "static-1.12583",
  "growth-feature-usage-data": "static-1.5166",
  "automation-ui-routing": "static-1.16103",
  "automation-ui-source-apps": "static-1.13825",
  "social-insights-client-types": "static-1.18114",
  "user-configuration-lib": "static-1.25692",
  "tinymce-themes": "static-1.52239",
  "interframe": "static-3.3721",
  "tinymce-data": "static-1.36354",
  "tinymce-plugins": "static-1.53383",
  "ContentData": "static-1.63864",
  "marketing-email-service-types": "static-1.1464",
  "sales-views-client-types": "static-1.3264",
  "ui-signature-editor": "static-1.14278",
  "developer-experience-shared-components": "static-1.9130",
  "stripe-connect-js": "static-1.41",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "automation-ui-usage-tracking": "static-1.16145",
  "form-builder-ui": "static-1.8045",
  "ui-deal-management-components-lib": "static-1.16015",
  "ai-rendering-library": "static-1.5687",
  "calendar-integration-client-types": "static-1.2654",
  "calendar-integration-events-lib": "static-1.4746",
  "crm-index-associations-lib": "static-1.5344",
  "react-window": "static-1.13",
  "ai-studio-lib": "static-1.6431",
  "embedded-academy-lib": "static-1.10586",
  "marketplace-ui-reviews": "static-1.14886",
  "marketplace-ui-tracking": "static-1.9101",
  "app-users-service-client": "static-1.4139",
  "app-users-service-types": "static-1.3547",
  "framework-listing-lib": "static-2.23404",
  "mini-checkout-client": "static-1.24526",
  "onboarding-utils": "static-1.4293",
  "ui-coaching-tips-shared-config": "static-1.23614",
  "NamespacedHubStyle": "static-2.8320",
  "layout-dnd-components": "static-1.10869",
  "layout-dnd-utils": "static-1.9844",
  "ui-brand-identity-lib": "static-1.9383",
  "apps-service-types": "static-1.3014",
  "oauth-service-types": "static-1.3230",
  "automation-ui-types": "static-1.14743",
  "highlight.js": "static-1.45",
  "automation-ui-action-features": "static-1.50409",
  "academy-common-lib": "static-1.10046",
  "customer-data-views-management": "static-1.22636",
  "touchless-buying-components": "static-1.3549",
  "merchandise-lib": "static-1.223",
  "settings-content-modals": "static-1.41024",
  "layout-data-lib": "static-1.8169",
  "ads-client-types": "static-1.17660",
  "automation-actions-service-types": "static-1.3432",
  "automation-applications-service-types": "static-1.2674",
  "automation-ui-action-fields": "static-1.33811",
  "automation-ui-associations": "static-1.15353",
  "automation-ui-enrollment": "static-1.52080",
  "automation-ui-flow-core": "static-1.16068",
  "automation-ui-formula-editor": "static-1.12151",
  "automation-ui-i18n": "static-1.16136",
  "automation-ui-references": "static-1.16091",
  "crm-properties-common-lib": "static-1.4596",
  "data-token-views": "static-1.14285",
  "fuzzy": "static-1.8",
  "messaging-editing-lib": "static-1.41344",
  "skills-lib": "static-1.25579",
  "ui-addon-automation-embed": "static-1.12503",
  "academy-service-client": "static-1.2688",
  "crm-export-dialog": "static-1.5223",
  "react-beautiful-dnd": "static-1.13",
  "checkout-sdk": "static-3.21370",
  "pricing-pages-ui-components": "static-1.8511",
  "upgrade-catalog-service-types": "static-1.2728",
  "access-control-lib": "static-1.9393",
  "EmailComponents": "static-1.49893",
  "EmailData": "static-1.48569",
  "redux-less": "static-2.8402",
  "crm-association-components-lib": "static-1.5385",
  "messaging-publishing-lib": "static-1.41296",
  "mobile-messaging-management-lib": "static-1.30004",
  "data-ops-fullstory": "static-1.4260",
  "workflows-copilot-service-types": "static-1.1573",
  "ContentEditorUI": "static-2.72442",
  "short-messages-app-service-client": "static-1.3009",
  "ui-tool-access": "static-1.9020",
  "web-interactives-components": "static-1.11708",
  "web-interactives-data": "static-1.11709",
  "conversations-thread-view": "static-1.72139",
  "conversations-visibility-tools": "static-1.4710",
  "hub-http-rxjs": "static-1.620",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "pricing-pages-api": "static-1.8373",
  "ContentComponents": "static-2.66745",
  "marketing-contacts-lib": "static-1.8089",
  "messaging-management-lib": "static-1.12856",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.4024",
  "copilot-plugins": "static-1.6909",
  "cta-picker": "static-1.32185",
  "editor-components": "static-1.11955",
  "editor-iframe-lib": "static-1.7268",
  "error-messaging-js": "static-1.4228",
  "pictos": "static-7.161",
  "redux-request-state": "static-1.9537",
  "smart-content-core": "static-1.38052",
  "smart-content-lib": "static-1.38704",
  "social-composer-lib": "static-1.53967",
  "structured-content-lib": "static-1.20940",
  "theme-previewer-lib": "static-1.48818",
  "tinymce-copilot": "static-1.12337",
  "ui-active-theme-content-creator-lib": "static-1.33017",
  "ui-memberships-settings-lib": "static-1.29223",
  "xray-recommendation-lib": "static-1.6174",
  "calling-integration-help-desk": "static-1.20151",
  "demographics-service-types": "static-1.800",
  "eligibility-engine-service-types": "static-1.2332",
  "personalization-service-types": "static-1.2153",
  "trials-service-types": "static-1.3051",
  "simple-menus-core": "static-1.13710",
  "simple-menus-lib": "static-1.15227",
  "videoconference-integration-components": "static-1.5123",
  "jquery": "static-3.6",
  "codemirror-dlb": "static-1.53998",
  "redux-undo": "static-1.10",
  "seamless-immutable": "static-7.6"
},
  depPathPrefixes: {
  "crm-records-ui": "/crm-records-ui/static-1.78221",
  "ably": "/ably/static-2.2",
  "ably-hubspot-js": "/ably-hubspot-js/static-2.3504",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5426",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3709",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3929",
  "call-widget-addon": "/call-widget-addon/static-2.28748",
  "calling-global-api": "/calling-global-api/static-1.58642",
  "calling-internal-common": "/calling-internal-common/static-1.30168",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.60024",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.39374",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.7039",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.36736",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.71349",
  "card-properties-lib": "/card-properties-lib/static-1.39469",
  "client-types": "/client-types/static-1.377",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.7055",
  "copilot-toolkit": "/copilot-toolkit/static-1.6936",
  "crm_data": "/crm_data/static-4.87280",
  "crm_ui": "/crm_ui/static-5.87238",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.41797",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.31719",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.47301",
  "crm-cards": "/crm-cards/static-1.40068",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.38771",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.38618",
  "crm-command-handler": "/crm-command-handler/static-1.31595",
  "crm-common-dlb": "/crm-common-dlb/static-1.4241",
  "crm-events-data": "/crm-events-data/static-1.56420",
  "crm-fe-perf": "/crm-fe-perf/static-1.21932",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22732",
  "crm-links": "/crm-links/static-1.5032",
  "crm-message-bus": "/crm-message-bus/static-1.37527",
  "crm-object-map": "/crm-object-map/static-1.2277",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.19754",
  "crm-timeline": "/crm-timeline/static-1.84745",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.33085",
  "customer-data-communicator": "/customer-data-communicator/static-1.40868",
  "customer-data-email": "/customer-data-email/static-1.15962",
  "customer-data-objects": "/customer-data-objects/static-1.6561",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6557",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.41676",
  "customer-data-tracking": "/customer-data-tracking/static-1.5777",
  "data-fetching-client": "/data-fetching-client/static-1.8567",
  "dispatcher": "/dispatcher/static-1.113",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.306",
  "feedback-loader": "/feedback-loader/static-1.26781",
  "foundations-components": "/foundations-components/static-1.6145",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.968",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5717",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7313",
  "framework-data-table": "/framework-data-table/static-2.8914",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4043",
  "highcharts": "/highcharts/static-8.81",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6940",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3770",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10451",
  "I18n": "/I18n/static-7.1395",
  "immutable": "/immutable/static-2.19",
  "jasmine-console-invariants": "/jasmine-console-invariants/static-1.1672",
  "jasmine-immutable": "/jasmine-immutable/static-1.1899",
  "jasmine-runner": "/jasmine-runner/static-1.5355",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.5977",
  "MeetingsLib": "/MeetingsLib/static-2.53856",
  "msw": "/msw/static-1.39",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2892",
  "onboarding-tours": "/onboarding-tours/static-1.14598",
  "PortalIdParser": "/PortalIdParser/static-2.284",
  "quartz": "/quartz/static-1.5689",
  "quartz-core": "/quartz-core/static-1.4908",
  "quick-fetch": "/quick-fetch/static-1.3079",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.75098",
  "raven": "/raven/static-3.4818",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.54",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-dom": "/react-dom/static-7.85",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.4425",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.27459",
  "reference-resolvers": "/reference-resolvers/static-1.7090",
  "reporting-data": "/reporting-data/static-1.62291",
  "reporting-dlb": "/reporting-dlb/static-1.55209",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.4226",
  "reporting-visualizations": "/reporting-visualizations/static-1.54368",
  "sales-clients-common": "/sales-clients-common/static-1.46429",
  "settings-ui-lib": "/settings-ui-lib/static-1.11478",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8157",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1200",
  "ui-addon-opt": "/ui-addon-opt/static-4.7535",
  "UIComponents": "/UIComponents/static-3.7398",
  "universal-associations-select": "/universal-associations-select/static-1.9756",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.4426",
  "usage-tracker": "/usage-tracker/static-1.6408",
  "usage-tracker-core": "/usage-tracker-core/static-1.6258",
  "webpack-env": "/webpack-env/static-1.54",
  "ai-catchup-cards-lib": "/ai-catchup-cards-lib/static-1.3547",
  "avatar-components": "/avatar-components/static-1.1409",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.41541",
  "call-timeline-event": "/call-timeline-event/static-1.51943",
  "calling-error-reporting": "/calling-error-reporting/static-1.30174",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.14271",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.30682",
  "calling-ui-library": "/calling-ui-library/static-1.65941",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.33543",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.2810",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.16241",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.15322",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.32147",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.7105",
  "composer-plugins": "/composer-plugins/static-1.67296",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.30682",
  "conversations-message-history": "/conversations-message-history/static-1.10038",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.30072",
  "crm_components": "/crm_components/static-3.87280",
  "crm_schema": "/crm_schema/static-3.87318",
  "crm_universal": "/crm_universal/static-1.20721",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.41250",
  "crm-cards-dnd": "/crm-cards-dnd/static-3.1095",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.15648",
  "crm-display-components": "/crm-display-components/static-1.20780",
  "crm-extension": "/crm-extension/static-1.36737",
  "crm-legacy-links": "/crm-legacy-links/static-1.72167",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.22254",
  "crm-realtime-lib": "/crm-realtime-lib/static-1.98",
  "crm-object-preview": "/crm-object-preview/static-1.22004",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4224",
  "crm-ui-legacy-tracking-page-view": "/crm-ui-legacy-tracking-page-view/static-1.68298",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.524",
  "customer-data-filters": "/customer-data-filters/static-1.48326",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11829",
  "customer-data-properties": "/customer-data-properties/static-1.46466",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6882",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11939",
  "customer-data-rte": "/customer-data-rte/static-1.29472",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8655",
  "deal-registration-ui": "/deal-registration-ui/static-1.30510",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.40337",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.40243",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.20797",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.19505",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.20508",
  "email-confirm-ui": "/email-confirm-ui/static-2.4522",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.21078",
  "ExportDialog": "/ExportDialog/static-6.9317",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.540",
  "file-manager-components": "/file-manager-components/static-1.19152",
  "FileManagerLib": "/FileManagerLib/static-1.34793",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.6218",
  "foundations-assets": "/foundations-assets/static-1.3849",
  "foundations-theming": "/foundations-theming/static-1.3251",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5812",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.14188",
  "HubStyle": "/HubStyle/static-2.10759",
  "icons": "/icons/static-2.592",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.17856",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.10395",
  "integration-settings-components": "/integration-settings-components/static-1.10924",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.34826",
  "metrics-js": "/metrics-js/static-1.8459",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.352",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6761",
  "nav-meta": "/nav-meta/static-1.25788",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.43040",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.43090",
  "playbooks-modal": "/playbooks-modal/static-1.75963",
  "playlists-lib": "/playlists-lib/static-1.7091",
  "products-ui-components": "/products-ui-components/static-1.35938",
  "property-history-panel": "/property-history-panel/static-1.19622",
  "property-management-iframe": "/property-management-iframe/static-1.8758",
  "property-translator": "/property-translator/static-1.4352",
  "react-colorpicker": "/react-colorpicker/static-2.9203",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-rhumb": "/react-rhumb/static-1.15503",
  "react-select-plus": "/react-select-plus/static-1.65",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6944",
  "reporting-action-components": "/reporting-action-components/static-1.36903",
  "reporting-enablement": "/reporting-enablement/static-1.17825",
  "reporting-ui-components": "/reporting-ui-components/static-2.59568",
  "rich-text-lib": "/rich-text-lib/static-1.17649",
  "rpc-client-utils": "/rpc-client-utils/static-1.3667",
  "SafeStorage": "/SafeStorage/static-1.3339",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.7301",
  "sanitize-text": "/sanitize-text/static-1.7102",
  "segment-references-panel-lib": "/segment-references-panel-lib/static-1.50988",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.24349",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.24546",
  "settings-ui-nav": "/settings-ui-nav/static-2.9031",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.163",
  "styled-components": "/styled-components/static-2.64",
  "subscriptions-components": "/subscriptions-components/static-1.41877",
  "timezone-utils": "/timezone-utils/static-2.4174",
  "transcript-sidebar": "/transcript-sidebar/static-1.63540",
  "transmute": "/transmute/static-2.29",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9967",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9849",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7826",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.11321",
  "ui-addon-teams": "/ui-addon-teams/static-1.19958",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16204",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.9245",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7837",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.13122",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.9175",
  "ui-product-approvals": "/ui-product-approvals/static-1.24225",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8996",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5351",
  "usage-tracker-container": "/usage-tracker-container/static-1.6398",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4094",
  "atom": "/atom/static-1.4104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "planout": "/planout/static-5.12",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sanitize": "/sanitize/static-1.3312",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
  "raven-hubspot": "/raven-hubspot/static-1.5125",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "react-redux": "/react-redux/static-7.16",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2558",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1966",
  "quartz-webpack": "/quartz-webpack/static-1.1913",
  "hs-promise-utils": "/hs-promise-utils/static-1.4477",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-client-types": "/chatspot-client-types/static-1.8823",
  "chatspot-core": "/chatspot-core/static-1.16248",
  "ContentUtils": "/ContentUtils/static-1.63788",
  "foundations-theming-base": "/foundations-theming-base/static-1.2236",
  "hs-story-utils": "/hs-story-utils/static-1.8312",
  "sassPrefix": "/sassPrefix/static-1.132",
  "ui-fonts": "/ui-fonts/static-1.332",
  "ui-images": "/ui-images/static-2.872",
  "graphql": "/graphql/static-1.59",
  "calling-client-interface": "/calling-client-interface/static-1.71181",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18148",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.18345",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.26571",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.52318",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.5106",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5438",
  "content-assistance-lib": "/content-assistance-lib/static-1.6483",
  "conversations-async-data": "/conversations-async-data/static-2.6590",
  "conversations-prop-types": "/conversations-prop-types/static-1.6386",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6314",
  "customer-data-content": "/customer-data-content/static-1.24757",
  "immer": "/immer/static-1.33",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "self-service-api": "/self-service-api/static-1.9143",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10003",
  "onboarding-scopes": "/onboarding-scopes/static-1.5492",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6829",
  "campaigns-lib": "/campaigns-lib/static-1.22822",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.32575",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.26971",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.7005",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3209",
  "growth-payments-core": "/growth-payments-core/static-1.21588",
  "payment-link-components": "/payment-link-components/static-1.19292",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.9882",
  "persist-promise": "/persist-promise/static-1.2682",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.15119",
  "draft-content-plugins": "/draft-content-plugins/static-1.24836",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "FireAlarmUi": "/FireAlarmUi/static-1.3722",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2887",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.13006",
  "portal-alert-banners-lib": "/portal-alert-banners-lib/static-1.1132",
  "react-virtualized": "/react-virtualized/static-2.74",
  "reselect": "/reselect/static-2.16",
  "sequences-lib": "/sequences-lib/static-1.6123",
  "superstore": "/superstore/static-1.3716",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.22723",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.10591",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3048",
  "utility-belt": "/utility-belt/static-1.1492",
  "zustand": "/zustand/static-1.51",
  "crm-events-components": "/crm-events-components/static-1.56406",
  "hub-http-contrib": "/hub-http-contrib/static-1.2097",
  "prosemirror": "/prosemirror/static-1.13",
  "react-dnd-compat": "/react-dnd-compat/static-1.3598",
  "task-forms-lib": "/task-forms-lib/static-1.36750",
  "task-queues": "/task-queues/static-1.29733",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7729",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.4532",
  "react-grid-layout": "/react-grid-layout/static-3.35",
  "crm-actions": "/crm-actions/static-1.5020",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.36354",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.3536",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.14786",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.68728",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.68587",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.28924",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.36587",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.22274",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.34511",
  "customer-data-modals": "/customer-data-modals/static-1.3786",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.10740",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.52153",
  "merge-modal-lib": "/merge-modal-lib/static-1.7452",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.23111",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.25668",
  "property-description-translator": "/property-description-translator/static-1.2804",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.8131",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.1173",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6587",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.53192",
  "outpost": "/outpost/static-1.3294",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3007",
  "user-context": "/user-context/static-1.4134",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.32197",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4638",
  "analytics_js": "/analytics_js/static-1.3442",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.39567",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.18145",
  "crm-events": "/crm-events/static-1.56413",
  "feedback-schema": "/feedback-schema/static-1.49636",
  "FileManagerCore": "/FileManagerCore/static-1.34652",
  "flux-actions": "/flux-actions/static-1.276",
  "flywheel-lead-visibility-lib": "/flywheel-lead-visibility-lib/static-1.1996",
  "forms-utils-lib": "/forms-utils-lib/static-1.10428",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.81552",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3665",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.13355",
  "integrations-lib": "/integrations-lib/static-1.11168",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4472",
  "MeetingsBase": "/MeetingsBase/static-1.55448",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.35792",
  "project-storage": "/project-storage/static-1.3636",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.43226",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.38471",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.97055",
  "react-table": "/react-table/static-1.15",
  "report-customization-components": "/report-customization-components/static-1.9292",
  "reporting-snowflake": "/reporting-snowflake/static-1.50912",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7912",
  "salesImages": "/salesImages/static-1.501",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5980",
  "share-transcript-modal": "/share-transcript-modal/static-1.53185",
  "social-components-lib": "/social-components-lib/static-1.29209",
  "StyleGuideUI": "/StyleGuideUI/static-3.464",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.14555",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6962",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8552",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4137",
  "ui-tour-react": "/ui-tour-react/static-1.10922",
  "urlinator": "/urlinator/static-1.3478",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.14180",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.3286",
  "quotes-client-types": "/quotes-client-types/static-1.32467",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2904",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3016",
  "external-options-client-types": "/external-options-client-types/static-1.3223",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3318",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.34570",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.50079",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.17682",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.13703",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.66384",
  "wootric-nps": "/wootric-nps/static-1.5840",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2414",
  "floating-ui": "/floating-ui/static-1.29",
  "framer-motion": "/framer-motion/static-1.41",
  "react-aria": "/react-aria/static-1.39",
  "tanstack-table": "/tanstack-table/static-1.23",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3166",
  "customer-data-associations": "/customer-data-associations/static-1.6140",
  "smart-property-lib": "/smart-property-lib/static-1.1472",
  "testing-library": "/testing-library/static-1.121",
  "HeadJS": "/HeadJS/static-2.581",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2051",
  "i18n-data": "/i18n-data/static-1.198",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.3281",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3630",
  "laboratory-lib": "/laboratory-lib/static-3.6176",
  "react-transition-group": "/react-transition-group/static-1.7",
  "redux-actions": "/redux-actions/static-3.7",
  "signup-constants": "/signup-constants/static-1.16530",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.18540",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6992",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4825",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4822",
  "usage-tracker-public": "/usage-tracker-public/static-1.6219",
  "viral-links-lib": "/viral-links-lib/static-1.5821",
  "ts-schema": "/ts-schema/static-1.3231",
  "growth-data-modal": "/growth-data-modal/static-1.4163",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2038",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.169",
  "navigation-components": "/navigation-components/static-1.14151",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6377",
  "ui-universal-auth": "/ui-universal-auth/static-1.7753",
  "quartz-core-utils": "/quartz-core-utils/static-1.2556",
  "hub-http-janus": "/hub-http-janus/static-1.654",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7229",
  "hubspotter-http": "/hubspotter-http/static-1.3689",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7227",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11370",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3874",
  "csstype": "/csstype/static-1.38",
  "call-summary": "/call-summary/static-1.33334",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.6640",
  "reporting-client-types": "/reporting-client-types/static-1.2019",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.23629",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9407",
  "rxjs": "/rxjs/static-5.10",
  "react-flip-move": "/react-flip-move/static-1.47",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3430",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.11288",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4189",
  "crm-component-utils": "/crm-component-utils/static-1.35030",
  "crm-properties-list": "/crm-properties-list/static-1.34055",
  "activity-history-lib": "/activity-history-lib/static-1.3134",
  "assisted-buying-components": "/assisted-buying-components/static-1.6054",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.12493",
  "company-details-components": "/company-details-components/static-1.4871",
  "company-details-service-types": "/company-details-service-types/static-1.2894",
  "final-form": "/final-form/static-1.40",
  "flywheel-recent-conversions-lib": "/flywheel-recent-conversions-lib/static-1.2804",
  "industries-core": "/industries-core/static-1.5696",
  "payment-method-components": "/payment-method-components/static-1.5518",
  "quote-checkout-common-lib": "/quote-checkout-common-lib/static-1.9953",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.2530",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3204",
  "conversations-calling-message": "/conversations-calling-message/static-1.55721",
  "crm-events-viz-test-utils": "/crm-events-viz-test-utils/static-1.17545",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.30907",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.51",
  "worker-connection-library": "/worker-connection-library/static-1.12735",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2643",
  "cv-backend-services": "/cv-backend-services/static-1.1221",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4187",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.18228",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4026",
  "qrcode-generator": "/qrcode-generator/static-1.44",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7873",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.11577",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7872",
  "immutable-less": "/immutable-less/static-1.3490",
  "composer-data": "/composer-data/static-1.26210",
  "conversations-http": "/conversations-http/static-1.3738",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14946",
  "conversations-platform": "/conversations-platform/static-1.3423",
  "conversations-thread-data": "/conversations-thread-data/static-1.63408",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5964",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.40522",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.14423",
  "ai-dynamic-card": "/ai-dynamic-card/static-1.969",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.6034",
  "bundle-about-card": "/bundle-about-card/static-1.1803",
  "bundle-items-card": "/bundle-items-card/static-1.2447",
  "buyer-intent-card": "/buyer-intent-card/static-1.17114",
  "buying-group-card": "/buying-group-card/static-1.1561",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.31030",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.22188",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.3128",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.12157",
  "card-flywheel-domain-review-history-lib": "/card-flywheel-domain-review-history-lib/static-1.1785",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.12157",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.3858",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.5439",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.7563",
  "card-lead-insights": "/card-lead-insights/static-1.10883",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.25913",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.3239",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.15838",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.26918",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.21283",
  "card-prospecting-research-agent": "/card-prospecting-research-agent/static-1.3771",
  "card-target-account-signals": "/card-target-account-signals/static-1.2320",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.10428",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.12275",
  "commerce-billing-engine-lib": "/commerce-billing-engine-lib/static-1.2593",
  "commerce-payment-dispute-card": "/commerce-payment-dispute-card/static-1.1000",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.35009",
  "crm-associations-table": "/crm-associations-table/static-1.36879",
  "crm-attribution-report": "/crm-attribution-report/static-1.1333",
  "crm-clv-report": "/crm-clv-report/static-1.3667",
  "crm-csat": "/crm-csat/static-1.939",
  "crm-data-highlights": "/crm-data-highlights/static-1.37417",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.36578",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.28132",
  "crm-nps": "/crm-nps/static-1.815",
  "crm-property-history": "/crm-property-history/static-1.12115",
  "crm-quick-actions": "/crm-quick-actions/static-1.13565",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.13993",
  "crm-report": "/crm-report/static-1.37624",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.14211",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.32588",
  "crm-statistics": "/crm-statistics/static-1.26633",
  "custom-events-card-lib": "/custom-events-card-lib/static-1.681",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.5553",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.14251",
  "deal-summary-components": "/deal-summary-components/static-1.17068",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.23597",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.3028",
  "guided-actions-card": "/guided-actions-card/static-1.10278",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.7900",
  "health-score-card-lib": "/health-score-card-lib/static-1.17534",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.10946",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.9280",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.26506",
  "lead-scores-card": "/lead-scores-card/static-1.13584",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.30903",
  "partner-ai-summary-crm-card": "/partner-ai-summary-crm-card/static-1.3219",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.24394",
  "playbooks-card": "/playbooks-card/static-1.38673",
  "predictive-scores-card": "/predictive-scores-card/static-1.26666",
  "process-guide-cards": "/process-guide-cards/static-1.4062",
  "products-cards-lib": "/products-cards-lib/static-1.5009",
  "purchase-history-lib": "/purchase-history-lib/static-1.16085",
  "ui-google-drive-attachments": "/ui-google-drive-attachments/static-1.2651",
  "ui-google-drive-insights": "/ui-google-drive-insights/static-1.2653",
  "content-embed-lib": "/content-embed-lib/static-1.6285",
  "remote-ui": "/remote-ui/static-1.40",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.10063",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.6357",
  "deep-diff": "/deep-diff/static-1.5",
  "commerce-products-lib": "/commerce-products-lib/static-1.5418",
  "google-libphonenumber": "/google-libphonenumber/static-1.12",
  "video-components-external": "/video-components-external/static-1.6515",
  "video-data-lib": "/video-data-lib/static-1.30168",
  "FileManagerImages": "/FileManagerImages/static-1.32303",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1734",
  "batch-promise": "/batch-promise/static-1.524",
  "knowledge-content-types": "/knowledge-content-types/static-1.7757",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8879",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.58790",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.14557",
  "marketplace-embed": "/marketplace-embed/static-1.17353",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2847",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4589",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1888",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.34195",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.13886",
  "property-management-common": "/property-management-common/static-1.1044",
  "dashboard-lib": "/dashboard-lib/static-1.76507",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7597",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.8696",
  "html-to-image": "/html-to-image/static-1.30",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-plugins": "/reporting-plugins/static-1.7285",
  "reporting-reports": "/reporting-reports/static-1.61974",
  "data-token-picker": "/data-token-picker/static-1.14304",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3289",
  "account-and-billing-components": "/account-and-billing-components/static-1.16837",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4947",
  "subscriptions-client": "/subscriptions-client/static-1.42119",
  "magpie-lib": "/magpie-lib/static-1.4595",
  "navigation-messaging": "/navigation-messaging/static-1.3478",
  "feature-store-service-types": "/feature-store-service-types/static-1.3643",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3650",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3634",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3094",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.33",
  "cms-field-types": "/cms-field-types/static-1.3719",
  "content-icons-ui": "/content-icons-ui/static-1.1934",
  "attribution-lib": "/attribution-lib/static-1.38225",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.8718",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5623",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.7003",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4093",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2655",
  "fsm": "/fsm/static-1.2676",
  "policy-lib": "/policy-lib/static-1.5708",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.16944",
  "automation-ui-core": "/automation-ui-core/static-2.16679",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.15039",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.11793",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.50095",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.24063",
  "magpie-types": "/magpie-types/static-1.4055",
  "simple-logging-lib": "/simple-logging-lib/static-1.1973",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.12473",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6067",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.23943",
  "audio-components": "/audio-components/static-1.4618",
  "video-components": "/video-components/static-1.8518",
  "video-embed": "/video-embed/static-1.31007",
  "flywheel-reject-ql-lib": "/flywheel-reject-ql-lib/static-1.2825",
  "portal-details-components": "/portal-details-components/static-1.14852",
  "forms-ai-lib": "/forms-ai-lib/static-1.2393",
  "react-tinymce": "/react-tinymce/static-1.51143",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1314",
  "tinymce-config": "/tinymce-config/static-2.50269",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.8583",
  "meetings-client-types": "/meetings-client-types/static-1.2866",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.8319",
  "data-model-commons-lib": "/data-model-commons-lib/static-1.7830",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5408",
  "messaging-types-lib": "/messaging-types-lib/static-1.41080",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.5099",
  "products-iframe-lib": "/products-iframe-lib/static-1.3744",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7612",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7375",
  "emoji-regex": "/emoji-regex/static-1.7",
  "idb-keyval": "/idb-keyval/static-1.21",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6799",
  "trellis-story-utils": "/trellis-story-utils/static-1.3501",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2511",
  "storybook-react": "/storybook-react/static-1.4",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.18295",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.10312",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2920",
  "buying-experience-components": "/buying-experience-components/static-1.8784",
  "checkout-service-types": "/checkout-service-types/static-1.3004",
  "growth-pro-utils-lib": "/growth-pro-utils-lib/static-1.9394",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.13463",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.5443",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.7121",
  "routing-ui": "/routing-ui/static-1.16818",
  "codemirror": "/codemirror/static-5.72",
  "react-codemirror": "/react-codemirror/static-1.9541",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2830",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2190",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.662",
  "commerce-products-api": "/commerce-products-api/static-1.366",
  "buyer-intent-lib": "/buyer-intent-lib/static-1.1776",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.3213",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.3097",
  "recent-activities-card": "/recent-activities-card/static-1.54270",
  "submissions-lib": "/submissions-lib/static-1.42455",
  "ui-forms-components": "/ui-forms-components/static-1.8423",
  "customer-success-client-types": "/customer-success-client-types/static-1.15506",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.13136",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.14372",
  "guided-actions-lib": "/guided-actions-lib/static-1.15651",
  "schedule-lib": "/schedule-lib/static-1.11075",
  "framework-scoring-components-lib": "/framework-scoring-components-lib/static-1.12203",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.72429",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.63170",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.72436",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.72450",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.72451",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.72450",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.50848",
  "card-customer-success-lib": "/card-customer-success-lib/static-1.655",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.64175",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.39723",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.41316",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.41317",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.42579",
  "card-invoices-lib": "/card-invoices-lib/static-1.51970",
  "card-lists-lib": "/card-lists-lib/static-1.66921",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.51752",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.51751",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.32832",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.37531",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.32439",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.52704",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.79902",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.34195",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.72591",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.51822",
  "card-target-account-lib": "/card-target-account-lib/static-1.68534",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.69254",
  "card-workflows-lib": "/card-workflows-lib/static-1.68675",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.22749",
  "invoices-card-lib": "/invoices-card-lib/static-1.52222",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.32731",
  "orders-card-lib": "/orders-card-lib/static-1.17399",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.15758",
  "recording-preview-card": "/recording-preview-card/static-1.12808",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.36218",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.27753",
  "sales-execution-components": "/sales-execution-components/static-1.9172",
  "process-guide-chirp": "/process-guide-chirp/static-1.3894",
  "gapi-client-types": "/gapi-client-types/static-1.5",
  "google-picker-types": "/google-picker-types/static-1.5",
  "ui-google-drive-commons": "/ui-google-drive-commons/static-1.787",
  "ui-google-drive-picker": "/ui-google-drive-picker/static-1.2222",
  "content-media-compositions": "/content-media-compositions/static-2.10908",
  "immerable": "/immerable/static-1.3084",
  "media-bridge-lib": "/media-bridge-lib/static-1.16908",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.12334",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.14927",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.4826",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4891",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.3786",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.15587",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.12587",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.12583",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.5166",
  "automation-ui-routing": "/automation-ui-routing/static-1.16103",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.13825",
  "social-insights-client-types": "/social-insights-client-types/static-1.18114",
  "user-configuration-lib": "/user-configuration-lib/static-1.25692",
  "tinymce-themes": "/tinymce-themes/static-1.52239",
  "interframe": "/interframe/static-3.3721",
  "tinymce-data": "/tinymce-data/static-1.36354",
  "tinymce-plugins": "/tinymce-plugins/static-1.53383",
  "ContentData": "/ContentData/static-1.63864",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1464",
  "sales-views-client-types": "/sales-views-client-types/static-1.3264",
  "ui-signature-editor": "/ui-signature-editor/static-1.14278",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9130",
  "stripe-connect-js": "/stripe-connect-js/static-1.41",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.16145",
  "form-builder-ui": "/form-builder-ui/static-1.8045",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.16015",
  "ai-rendering-library": "/ai-rendering-library/static-1.5687",
  "calendar-integration-client-types": "/calendar-integration-client-types/static-1.2654",
  "calendar-integration-events-lib": "/calendar-integration-events-lib/static-1.4746",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.5344",
  "react-window": "/react-window/static-1.13",
  "ai-studio-lib": "/ai-studio-lib/static-1.6431",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.10586",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.14886",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.9101",
  "app-users-service-client": "/app-users-service-client/static-1.4139",
  "app-users-service-types": "/app-users-service-types/static-1.3547",
  "framework-listing-lib": "/framework-listing-lib/static-2.23404",
  "mini-checkout-client": "/mini-checkout-client/static-1.24526",
  "onboarding-utils": "/onboarding-utils/static-1.4293",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.23614",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8320",
  "layout-dnd-components": "/layout-dnd-components/static-1.10869",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9844",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.9383",
  "apps-service-types": "/apps-service-types/static-1.3014",
  "oauth-service-types": "/oauth-service-types/static-1.3230",
  "automation-ui-types": "/automation-ui-types/static-1.14743",
  "highlight.js": "/highlight.js/static-1.45",
  "automation-ui-action-features": "/automation-ui-action-features/static-1.50409",
  "academy-common-lib": "/academy-common-lib/static-1.10046",
  "customer-data-views-management": "/customer-data-views-management/static-1.22636",
  "touchless-buying-components": "/touchless-buying-components/static-1.3549",
  "merchandise-lib": "/merchandise-lib/static-1.223",
  "settings-content-modals": "/settings-content-modals/static-1.41024",
  "layout-data-lib": "/layout-data-lib/static-1.8169",
  "ads-client-types": "/ads-client-types/static-1.17660",
  "automation-actions-service-types": "/automation-actions-service-types/static-1.3432",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2674",
  "automation-ui-action-fields": "/automation-ui-action-fields/static-1.33811",
  "automation-ui-associations": "/automation-ui-associations/static-1.15353",
  "automation-ui-enrollment": "/automation-ui-enrollment/static-1.52080",
  "automation-ui-flow-core": "/automation-ui-flow-core/static-1.16068",
  "automation-ui-formula-editor": "/automation-ui-formula-editor/static-1.12151",
  "automation-ui-i18n": "/automation-ui-i18n/static-1.16136",
  "automation-ui-references": "/automation-ui-references/static-1.16091",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.4596",
  "data-token-views": "/data-token-views/static-1.14285",
  "fuzzy": "/fuzzy/static-1.8",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.41344",
  "skills-lib": "/skills-lib/static-1.25579",
  "ui-addon-automation-embed": "/ui-addon-automation-embed/static-1.12503",
  "academy-service-client": "/academy-service-client/static-1.2688",
  "crm-export-dialog": "/crm-export-dialog/static-1.5223",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "checkout-sdk": "/checkout-sdk/static-3.21370",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.8511",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2728",
  "access-control-lib": "/access-control-lib/static-1.9393",
  "EmailComponents": "/EmailComponents/static-1.49893",
  "EmailData": "/EmailData/static-1.48569",
  "redux-less": "/redux-less/static-2.8402",
  "crm-association-components-lib": "/crm-association-components-lib/static-1.5385",
  "messaging-publishing-lib": "/messaging-publishing-lib/static-1.41296",
  "mobile-messaging-management-lib": "/mobile-messaging-management-lib/static-1.30004",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.4260",
  "workflows-copilot-service-types": "/workflows-copilot-service-types/static-1.1573",
  "ContentEditorUI": "/ContentEditorUI/static-2.72442",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3009",
  "ui-tool-access": "/ui-tool-access/static-1.9020",
  "web-interactives-components": "/web-interactives-components/static-1.11708",
  "web-interactives-data": "/web-interactives-data/static-1.11709",
  "conversations-thread-view": "/conversations-thread-view/static-1.72139",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4710",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.620",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "pricing-pages-api": "/pricing-pages-api/static-1.8373",
  "ContentComponents": "/ContentComponents/static-2.66745",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.8089",
  "messaging-management-lib": "/messaging-management-lib/static-1.12856",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.4024",
  "copilot-plugins": "/copilot-plugins/static-1.6909",
  "cta-picker": "/cta-picker/static-1.32185",
  "editor-components": "/editor-components/static-1.11955",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.7268",
  "error-messaging-js": "/error-messaging-js/static-1.4228",
  "pictos": "/pictos/static-7.161",
  "redux-request-state": "/redux-request-state/static-1.9537",
  "smart-content-core": "/smart-content-core/static-1.38052",
  "smart-content-lib": "/smart-content-lib/static-1.38704",
  "social-composer-lib": "/social-composer-lib/static-1.53967",
  "structured-content-lib": "/structured-content-lib/static-1.20940",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.48818",
  "tinymce-copilot": "/tinymce-copilot/static-1.12337",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.33017",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.29223",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.6174",
  "calling-integration-help-desk": "/calling-integration-help-desk/static-1.20151",
  "demographics-service-types": "/demographics-service-types/static-1.800",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2332",
  "personalization-service-types": "/personalization-service-types/static-1.2153",
  "trials-service-types": "/trials-service-types/static-1.3051",
  "simple-menus-core": "/simple-menus-core/static-1.13710",
  "simple-menus-lib": "/simple-menus-lib/static-1.15227",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.5123",
  "jquery": "/jquery/static-3.6",
  "codemirror-dlb": "/codemirror-dlb/static-1.53998",
  "redux-undo": "/redux-undo/static-1.10",
  "seamless-immutable": "/seamless-immutable/static-7.6"
}
};
